export default {
  // ── Tiêu đề màn hình / popup ──────────────────────────────────────────────
  Title: {
    FileList:            'Hồ sơ giao dịch với KBNN',
    FileDetail:          'Hồ sơ giao dịch với KBNN',
    CheckStatusFromKBNN: 'Kiểm tra trạng thái hồ sơ từ KBNN',
    UpdateFromDVC:       'Cập nhật hồ sơ từ DVC',
    UpdateFromKBNN:       'Cập nhật hồ sơ từ KBNN',
    ChooseApprover:      'Gửi phê duyệt',
    ChooseApproverResend:'Gửi lại phê duyệt',
    LinkedFilePopup:     'Chọn hồ sơ liên kết',
    VoucherTemplatePopup:'Chọn mẫu chứng từ giao dịch với kho bạc',
    SettingFileCode:     'Thiết lập mã hồ sơ',
    Warning:             'Tệp đính kèm không hợp lệ',
    PullDebitAdvice:     'Cập nhật giấy báo nợ',
    TreasuryAccountInvalid: 'Số Tài khoản Kho bạc không hợp lệ',
    PullSignatureMetadata:'Cập nhật chữ ký',
    SyncAllToeTCTHA:    'Đồng bộ giấy báo nợ sang eTCTHA',
  },

  // ── Label form ────────────────────────────────────────────────────────────
  Label: {
    FileCode:              'Mã hồ sơ',
    TreasuryLocation:      'Giao dịch tại',
    CreatedDate:           'Ngày tạo',
    FileTitle:             'Tiêu đề hồ sơ',
    HasPaymentVoucher:     'Có chứng từ thanh toán',
    VoucherTemplateSection:'Mẫu chứng từ giao dịch với kho bạc',
    LinkedFileSection:     'Hồ sơ liên kết',
    AttachSection:         'Đính kèm tài liệu nhận',
    AttachHint:            'Hỗ trợ tệp định dạng jpg; png; pdf, tổng dung lượng các tệp tối đa 5MB',
    AttachNote:            'Nhập thông tin ghi chú của tài liệu',

    // Popup chọn mẫu chứng từ
    SelectBusiness:          'Chọn nghiệp vụ',
    AccountingVoucherNo:     'Số chứng từ kế toán',
    TransactionAccountNo:    'Số tài khoản giao dịch với KBNN',

    // Popup thiết lập mã hồ sơ
    HintDifferentSuffix:     'Đơn vị nên thiết lập hậu tố khác nhau cho các dữ liệu kế toán có chung mã quan hệ ngân sách.',
    ResetFileCode:           'Thiết lập lại mã hồ sơ giao dịch',
    ResetEVoucherCode:       'Thiết lập lại số chứng từ điện tử Kho bạc',
    Prefix:                  'Tiền tố',
    Suffix:                  'Hậu tố',
    AutoIncrement:           'Số tự tăng',
    Preview:                 'Xem trước',

    // Popup chọn người duyệt
    ChooseApproverHint:      'Chọn người xem và duyệt hồ sơ.',
    ApproverName:            'Họ và tên người duyệt',
    ApproverRole:            'Vai trò',

    // Popup hồ sơ liên kết
    DateRangeLabel:  'Khoảng thời gian',
    DateFrom:        'Từ',
    DateTo:          'Đến',
  },

  // ── Caption cột grid ──────────────────────────────────────────────────────
  Column: {
    FileCode:             'Mã hồ sơ',
    FileTitle:            'Tiêu đề hồ sơ',
    TreasuryLocation:     'Giao dịch tại',
    CreatedDate:          'Ngày tạo',
    RefNo:                'Số chứng từ',
    TransactionStatus:    'Trạng thái giao dịch',
    TreasuryStatus:       'Trạng thái hồ sơ trên KBNN',
    Description:          'Ghi chú',
    ApproverName:         'Người phê duyệt',
    TotalAmount:          'Số tiền',

    // Grid mẫu chứng từ (detail)
    Business:             'Nghiệp vụ',
    VoucherNo:            'Số chứng từ',
    VoucherTemplate:      'Mẫu chứng từ',
    TransactionAccount:   'Tài khoản giao dịch',
    ElectronicVoucherNo:  'Số chứng từ điện tử',
    VoucherStatus:        'Trạng thái chứng từ',
    eTCTHAStatus:        'Trạng thái eTCTHA',
    eTCTHAUpdate:         'Cập nhật ETCTHA',

    // Grid hồ sơ liên kết (detail)
    Stt:                  'STT',
    LinkedFileTitle:      'Tiêu đề',

    // Grid mẫu chứng từ (VoucherTemplatePopup)
    SelectVoucherTemplate: 'Chọn mẫu chứng từ giao dịch với kho bạc',
  },

  // ── Nút hành động ─────────────────────────────────────────────────────────
  Button: {
    View:                'Xem',
    ViewEdit:            'Xem/Sửa',
    SendApprove:         'Gửi duyệt',
    RejectApprove:       'Từ chối duyệt',
    AddVoucherTemplate:  'Thêm mẫu chứng từ',
    SelectLinkedFile:    'Chọn hồ sơ liên kết',
    UploadAttach:        'Tải tệp lên đính kèm',
    FetchData:           'Lấy dữ liệu',
    ViewAccountingVoucher: 'Xem chứng từ kế toán',
    Add:                 'Thêm',
    RefreshFileCode:     'Làm mới Mã hồ sơ',
    SettingFileCode:     'Thiết lập quy tắc sinh mã Mã hồ sơ',
    Close:               'Đóng',
    PushFPT:             'Cập nhật hồ sơ lên eTCTHA',
    OK:                  'Đồng ý',
  },

  // ── Vai trò người duyệt ───────────────────────────────────────────────────
  Role: {
    ChiefAccountant:          'Kế toán trưởng',
    DelegateChiefAccountant:  'Ủy quyền kế toán trưởng',
    HeadOfDepartment:         'Chủ tài khoản',
    DelegateHeadOfDepartment: 'Ủy quyền chủ tài khoản',
  },

  // ── Nghiệp vụ (business type) ─────────────────────────────────────────────
  BusinessType: {
    ChequeIssuance: 'Phát hành séc',
    CashReceipt:    'Phiếu thu',
  },

  // ── Toast / thông báo ─────────────────────────────────────────────────────
  Message: {
    ApproveFailed:              'Duyệt thất bại',
    AlreadySigned:              'Đã ký duyệt. Vui lòng chọn Thủ trưởng để gửi hồ sơ.',
    SendToDirectorSuccess:      'Gửi Thủ trưởng duyệt thành công',
    SendToDirectorFailed:       'Gửi Thủ trưởng duyệt thất bại',
    SendApproveSuccess:         'Gửi duyệt thành công',
    SendApproveFailed:          'Gửi duyệt thất bại',
    RejectApproveSuccess:       'Từ chối duyệt thành công',
    RejectApproveFailed:        'Từ chối duyệt thất bại',
    RejectApproveListSuccess:   'Từ chối duyệt hàng loạt thành công',
    RejectApproveListFailed:    'Từ chối duyệt hàng loạt thất bại',
    NoValidRecordToReject:      'Không có hồ sơ nào hợp lệ để từ chối duyệt (hồ sơ phải ở trạng thái Chờ KTT duyệt hoặc Chưa gửi Thủ trưởng)',
    NotSupportTemplate:         'Chưa hỗ trợ xem mẫu: {0}',
    FileNotSaved:               'Hồ sơ chưa được lưu',
    OpenFileFailed:             'Không thể mở file đính kèm.',
    FileTitleRequired:          'Tiêu đề hồ sơ không được để trống.',
    WaitingUpload:              'Vui lòng chờ tất cả tệp đính kèm tải lên xong.',
    UploadFailed:               'Tải lên tệp "{0}" thất bại.',
    AttachDuplicate:            'Tệp đính kèm "{0}" đã tồn tại. Vui lòng kiểm tra lại.',
    SettingFailed:              'Có lỗi xảy ra khi thiết lập.',
    TransactionAccountRequired: 'Thông tin Số tài khoản không được để trống.',
    VoucherNoRequired:          'Thông tin Số chứng từ kế toán không được bỏ trống.',
    SelectTemplateRequired:     'Bạn cần chọn ít nhất 1 Mẫu chứng từ giao dịch với kho bạc.',
    AddFailed:                  'Thêm không thành công',
    TreasuryAccountDiff:        'Số tài khoản Kho bạc đang chọn khác với Số tài khoản đã chọn ở chứng từ trước. Vui lòng kiểm tra lại',
    NoVoucherTemplate:          'Chưa chọn mẫu chứng từ thanh toán. Thêm mẫu chứng từ.',
    NoVoucherTemplatePrefix:    'Chưa chọn mẫu chứng từ thanh toán.',
    AttachRequired:             'Vui lòng tải lên tệp đính kèm.',
    SaveFailed:                 'Cất không thành công',
    UpdateKBNNStatusSuccess:    'Cập nhật trạng thái KBNN thành công',
    UpdateKBNNStatusFailed:     'Cập nhật trạng thái KBNN thất bại',
    UpdateDVCStatusSuccess:     'Cập nhật hồ sơ từ DVC thành công',
    UpdateDVCStatusFailed:      'Cập nhật hồ sơ từ DVC thất bại',
    PullDebitAdviceSuccess:     'Cập nhật giấy báo nợ thành công',
    PullDebitAdviceFailed:      'Cập nhật giấy báo nợ thất bại',
    PullSignatureMetadataSuccess:'Cập nhật chữ ký thành công',
    PullSignatureMetadataFailed: 'Cập nhật chữ ký thất bại',
    SyncAllToeTCTHASent:         'Đã gửi yêu cầu đồng bộ giấy báo nợ sang eTCTHA',
    SyncAllToeTCTHAInProgress:   'Đang có yêu cầu đồng bộ giấy báo nợ sang eTCTHA. Vui lòng chờ xử lý xong.',
    SyncAllToeTCTHANoData:       'Không có giấy báo nợ nào cần đồng bộ sang eTCTHA',
    SyncAllToeTCTHASuccess:      'Đồng bộ giấy báo nợ sang eTCTHA thành công',
    SyncAllToeTCTHAFailed:       'Đồng bộ giấy báo nợ sang eTCTHA thất bại',
    VoucherNotPaidYet:          'Chứng từ chưa được thanh toán hoặc chưa có giấy báo nợ',
    DownloadFailed:             'Tải file thất bại',
    NoRecoverFile:              'Không có dữ liệu in phục hồi',
    NoRejectReportFile:         'Không có file lý do từ chối từ KBNN',
    LinkedFileInfo:             'Hồ sơ liên kết',
    // ── Kết nối DVC ─────────────────────────────────────────────────────────
    ConnectSuccess:             'Kết nối thành công',
    ConnectFailed:              'Thông tin đăng nhập không chính xác. Vui lòng kiểm tra lại',
    ConnectFailedTitle:         'Kết nối không thành công',
    DisconnectSuccess:          'Hủy kết nối thành công',
    RequireConnectDVC:          'Bạn cần kết nối DVC để thực hiện chức năng này',
    RequireConnectDVCTitle:     'Không thể thực hiện',
    // ── Đẩy FPT ──────────────────────────────────────────────────────────────
    MappingNotFound:            'Không tìm thấy ánh xạ chứng từ',
    PushFPTSuccess:             'Đẩy FPT thành công',
    PushFPTFailed:              'Đẩy FPT thất bại',
  },

  // ── Tab kết nối DVC (EtreasuryProcessTab) ─────────────────────────────────
  Connect: {
    PageTitle:         'Kho bạc điện tử',
    SectionTitle:      'Kết nối DVC',
    BudgetCodeLabel:   'Mã QHNS',
    BudgetCodeTitle:   'Mã quan hệ ngân sách',
    UsernameLabel:     'Tên đăng nhập',
    PasswordLabel:     'Mật khẩu',
    ShowPassword:      'Hiển thị mật khẩu',
    HidePassword:      'Ẩn mật khẩu',
    AccountLabel:      'Tài khoản:',
    RoleLabel:         'Vai trò:',
    DisconnectButton:  'Hủy kết nối',
    ConnectButton:     'Kết nối',
    ConfirmButton:     'Đồng ý',
  },

  // ── Tooltip ───────────────────────────────────────────────────────────────
  Tooltip: {
    RefreshFileCode:  'Làm mới Mã hồ sơ',
    SettingFileCode:  'Thiết lập quy tắc sinh mã Mã hồ sơ',
    Cancel:           'Hủy (ESC)',
    Accept:           'Đồng ý',
  },
};
